import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './CartContext/CartContext';
import Header from './components/header';
import PhoneMenu from './components/phoneMenu';
import Hero from './components/hero';
import Velkommen from './components/velkommen';
import Nyheder from './components/nyheder';
import Om from './components/om';
import Footer from './components/footer';
import Supervision from './undersider/supervision/supervision';
import Kontakt from './undersider/kontakt/kontakt';
import Omos from './undersider/om os/omos';
import Medarbejder from './undersider/om os/medarbejder';
import Terapi from './undersider/terapi/terapi';
import TerapiSide from './undersider/terapi/terapiside/terapiside';
import Uddannelse from './undersider/uddannelse/uddannelse';
import UddannelseSide from './undersider/uddannelse/udannelsessider/uddannelsesside';
import PraktiskPriser from './undersider/praktiskpriser/praktiskpriser';
import Viden from './undersider/viden/viden';
import VidenArtikel from './undersider/viden/videnArtikel';
import Shop from './undersider/shop/shop';
import Produkt from './undersider/shop/produkt';
import Kurv from './undersider/shop/kurv';
import Login from './admin/login';
import AdminMain from './admin/adminMain';
import AdminForside from './admin/forside/adminForside';
import AdminNyheder from './admin/nyheder/adminNyheder';
import AdminOm from './admin/om os/adminOm';
import AdminTerapi from './admin/terapi/adminTerapi';
import AdminSupervision from './admin/supervision/adminSupervision';
import AdminUddannelse from './admin/uddannelse/adminUddannelse';
import AdminUddannelseEvents from './admin/uddannelse/adminUddannelseEvents';
import AdminPraktiskPriser from './admin/praktisk-priser/adminPraktiskPriser';
import AdminShop from './admin/shop/adminShop';
import AdminViden from './admin/viden/adminViden';
import AdminKontakt from './admin/kontakt/adminKontakt';
import './App.css';

function App() {
  return (
    <CartProvider>
      <Router>
        <div className="App">
        <Routes>
          {/* Admin routes */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<AdminMain />} />
          <Route path="/admin/forside" element={<AdminForside />} />
          <Route path="/admin/nyheder" element={<AdminNyheder />} />
          <Route path="/admin/om" element={<AdminOm />} />
          <Route path="/admin/terapi" element={<AdminTerapi />} />
          <Route path="/admin/supervision" element={<AdminSupervision />} />
          <Route path="/admin/uddannelse" element={<AdminUddannelse />} />
          <Route path="/admin/uddannelse/:id/events" element={<AdminUddannelseEvents />} />
          <Route path="/admin/praktisk-priser" element={<AdminPraktiskPriser />} />
          <Route path="/admin/shop" element={<AdminShop />} />
          <Route path="/admin/viden" element={<AdminViden />} />
          <Route path="/admin/kontakt" element={<AdminKontakt />} />
          <Route path="/admin/:section" element={<AdminMain />} />
          
          {/* Public routes */}
          <Route path="/*" element={
            <>
              <Header />
              <PhoneMenu />
              <main>
                <Routes>
                  <Route path="/" element={
                    <>
                      <Hero />
                      <Velkommen />
                      <Nyheder />
                      <Om />
                    </>
                  } />
                  <Route path="/supervision" element={<Supervision />} />
                  <Route path="/kontakt" element={<Kontakt />} />
                  <Route path="/om" element={<Omos />} />
                  <Route path="/om/:id" element={<Medarbejder />} />
                  <Route path="/terapi" element={<Terapi />} />
                  <Route path="/terapi/:id" element={<TerapiSide />} />
                  <Route path="/uddannelse" element={<Uddannelse />} />
                  <Route path="/uddannelse/:id" element={<UddannelseSide />} />
                  <Route path="/praktisk-priser" element={<PraktiskPriser />} />
                  <Route path="/viden" element={<Viden />} />
                  <Route path="/viden/:artikelId" element={<VidenArtikel />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/shop/:produktId" element={<Produkt />} />
                  <Route path="/kurv" element={<Kurv />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
    </CartProvider>
  );
}

export default App;
